import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import {
  SmartListFormFields,
  validationSchema,
} from 'shared/types/smart-list-form';

export const useSmartListForm = (
  submit: (values: SmartListFormFields) => void,
  initialValues?: SmartListFormFields,
) => {
  const { handleSubmit, ...formProps } = useForm<SmartListFormFields>({
    resolver: yupResolver(validationSchema),
    mode: 'onSubmit',
    defaultValues: initialValues,
  });

  const onSubmit = handleSubmit(({ name, color, icon }) =>
    submit({
      name,
      color,
      icon,
    }),
  );

  return {
    ...formProps,
    onSubmit,
    errors: formProps.formState.errors,
    isValid: formProps.formState.isValid,
  };
};
